export const isHtmlElement = (element: any): element is HTMLElement => {
  return element instanceof HTMLElement;
};
